import { css } from '@emotion/react'
import cx from 'classnames'
import { HTMLAttributes } from 'react'

import GiftIcon from './core/GiftIcon'
import UspCheckIcon from './core/UspCheckIcon/UspCheckIcon'
import VoucherEuroIcon from './core/VoucherEuroIcon/VoucherEuroIcon'
import VoucherPercentageIcon from './core/VoucherPercentageIcon/VoucherPercentageIcon'
import { CategoryBodyPromoCtaBannerPrimary } from './graphql/schema.generated'
import Button from './input/Button/Button'
import Icon from './media/Icon/Icon'
import paths from './paths'
import styles from './PrismicCategoryPromoCtaBanner.module.scss'
import theme from './theme'
import Heading from './typography/Heading'

type Props = Omit<
    CategoryBodyPromoCtaBannerPrimary,
    '__typename' | 'mobile' | 'desktop' | 'tablet'
> & { className?: HTMLAttributes<HTMLElement> }

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const iconMapping: Record<string, any> = {
    euro: VoucherEuroIcon,
    gift: GiftIcon,
    percentage: VoucherPercentageIcon,
    default: UspCheckIcon,
}

export const PrismicCategoryPromoCtaBanner = ({
    heading,
    content,
    buttonUrl,
    buttonText,
    button2Text,
    button2Url,
    icon,
    className,
}: Props) => {
    const iconName = icon?.toLowerCase()

    return (
        <section>
            <div className={cx(styles.container, className)}>
                <div className={styles.row}>
                    <Heading
                        className={styles.heading}
                        variant="h2"
                        element="h2"
                    >
                        {heading}
                    </Heading>

                    {iconName && (
                        <div className={styles.icon}>
                            <Icon
                                className={styles.icon}
                                name={iconName}
                                component={
                                    iconName in iconMapping
                                        ? iconMapping[iconName]
                                        : iconMapping.default
                                }
                                title={iconName}
                                css={css`
                                    fill: ${theme.colors.primary};
                                    height: auto;
                                `}
                            />
                        </div>
                    )}
                </div>
                <div className={cx(styles.row, styles.contents)}>
                    <div className={styles.text}>{content}</div>
                </div>
                <div className={cx(styles.row, styles.buttons)}>
                    <Button
                        to={buttonUrl ?? paths.home}
                        size="large"
                        variant="primary"
                        name="category-promo-cta-primary"
                        category="PrismicCategoryCtaBanner"
                    >
                        {buttonText}
                    </Button>

                    {button2Url && button2Text && (
                        <Button
                            to={button2Url}
                            size="large"
                            variant="link"
                            name="category-promo-cta-secondary"
                            category="PrismicCategoryCtaBanner"
                        >
                            {button2Text}
                        </Button>
                    )}
                </div>
            </div>
        </section>
    )
}
